import { Dropdown } from "@evergis/ui";
import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AttachmentsGrid } from "../../../../../../modules/FeatureCard/components/Attributes/components/Attachments/AttachmentsGrid";
import { NumberInput } from "../../../../../LabelSettings/styled";
import {
  GalleryContainer,
  GalleryContainerHeader,
  GalleryContainerSettings,
  GallerySetting,
  GallerySettingsLabel,
} from "../styled";
import { AlignmentOption, GallerySettings } from "./types";

export interface GalleryBlockProps {
  value?: GallerySettings;
  onChange?: (value?: GallerySettings) => void;
}

export const GalleryBlock: FC<GalleryBlockProps> = ({ value, onChange }) => {
  const { t } = useTranslation("dialogs");

  const options = useMemo(
    () => [
      {
        text: t("editResource.left"),
        value: AlignmentOption.Left,
      },
      {
        text: t("editResource.center"),
        value: AlignmentOption.Center,
      },
      {
        text: t("editResource.right"),
        value: AlignmentOption.Right,
      },
    ],
    [t],
  );

  return (
    <GalleryContainer>
      <GalleryContainerHeader>
        <div>{t("editResource.gallery")}</div>
        <GalleryContainerSettings>
          <GallerySetting>
            <GallerySettingsLabel>{t("editResource.height")}</GallerySettingsLabel>
            <NumberInput
              value={value?.height}
              width={"4.25rem"}
              min={176}
              max={468}
              onChange={height => onChange({ ...value, height })}
            />
          </GallerySetting>
          <GallerySetting>
            <GallerySettingsLabel>{t("editResource.width")}</GallerySettingsLabel>
            <NumberInput
              width={"4.25rem"}
              value={value?.width}
              min={312}
              max={832}
              onChange={width => onChange({ ...value, width })}
            />
          </GallerySetting>
          <GallerySetting>
            <GallerySettingsLabel>{t("editResource.alignment")}</GallerySettingsLabel>
            <Dropdown
              width={"7.25rem"}
              zIndex={1000}
              options={options}
              value={value?.alignment}
              onChange={([option]) => onChange({ ...value, alignment: option.value as AlignmentOption })}
            />
          </GallerySetting>
        </GalleryContainerSettings>
      </GalleryContainerHeader>

      <AttachmentsGrid isEdit pageSize={20} items={value?.items} onChange={items => onChange({ ...value, items })} />
    </GalleryContainer>
  );
};
